export default __webpack_public_path__ + "static/media/screen2.94f3d0f8.jpg";